import { mobileHeaderBreakPoint } from "@/utils/functions/global-constants";
import { convertImage, toBase64 } from "@/utils/functions/Images-functions";
import Image from "next/image";
import React from "react";

type Props = { mobile_src: string; alt?: string; priority?: boolean };
const PictureMobile: React.FC<Props> = ({ mobile_src, alt, priority }) => {
  return (
    <Image
      fetchPriority={priority ? "high" : undefined}
      loading={priority ? "eager" : "lazy"}
      src={mobile_src}
      alt={alt || "slider"}
      placeholder={"blur"}
      blurDataURL={`data:image/svg+xml;base64,${toBase64(
        convertImage(10, 10),
      )}`}
      sizes={`${mobileHeaderBreakPoint}px`}
      className="img-mobile"
      fill
      objectFit="fill"
      priority={priority}
    />
  );
};

export default PictureMobile;
